import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import ungroupedRoutesData from "../../const/RoutesList";
import { connect } from "react-redux";
import { filterResultsByPermission } from "../utils/urlPermissionChecker";

const SearchPage = (props) => {
    const accessToken = props.oidc?.user?.access_token;
    const [query, setQuery] = useState("");
    const [showResults, setShowResults] = useState(false);
    const [searchApiResults, setSearchApiResults] = useState([]);
    const history = useHistory();
    const debounceRef = useRef(null);
    var baseUrl = window._env_.REACT_APP_APIS;
    const useSemanticSearch = (() => {
        const val = window._env_?.UseSemanticSearch;
        if (val === true ) return true;
        if (val === false) return false;
        return false;
      })();
    console.log(baseUrl);
    
    // Get permissions from Redux state (stored in rolePermissions)
    const permissions = props.ReceiptReducer?.rolePermissions || {};
    // Get visible URLs from tree view (already filtered by permissions)
    const treeViewVisibleUrls = props.ReceiptReducer?.treeViewVisibleUrls || null;

    const callSearchApi = async (inputText) => {
        if (!useSemanticSearch) {
            console.warn("No base URL found. Falling back to local search...");
            const lowerInput = inputText.toLowerCase();
            const localResults = ungroupedRoutesData.filter(
                (item) =>
                    item.name.toLowerCase().includes(lowerInput) ||
                    item.value.toLowerCase().includes(lowerInput)
            );
            // Filter local results by permissions using tree view URLs
            const filteredResults = filterResultsByPermission(localResults, permissions, treeViewVisibleUrls);
            setSearchApiResults(filteredResults);
            setShowResults(true);
            return;
        }

        try {
            const response = await fetch(`${baseUrl}/ai/Search/GetUrls`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                },
                body: JSON.stringify({ Message: inputText })
            });

            if (response.ok) {
                const data = await response.json();
                // Filter API results by permissions using tree view URLs
                const filteredResults = filterResultsByPermission(data, permissions, treeViewVisibleUrls);
                setSearchApiResults(filteredResults);
                setShowResults(true);
            } else {
                console.error("Search API error");
                setSearchApiResults([]);
            }
        } catch (error) {
            console.error("Error calling search API:", error);
            setSearchApiResults([]);
        }
    };


    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);

        setShowResults(false);
        setSearchApiResults([]);

        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (value.trim().length > 0) {
            debounceRef.current = setTimeout(() => {
                callSearchApi(value);
            }, 500); // 500ms debounce
        }
    };

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && query.trim()) {
            if (debounceRef.current) clearTimeout(debounceRef.current);
            await callSearchApi(query);
        }
    };

    const handleExternalResultClick = (item) => {
        // Handle both API results (with url) and local search results (with value)
        const url = item.url || item.value;
        if (url) {
            history.push(url);
            setShowResults(false);
            setQuery("");
        }
    };

    return (
        <div style={{ padding: "10px" }}>
            <div style={{ textAlign: "center", position: "relative" }}>
                <div style={{ position: "relative", width: "60%", margin: "0 auto" }}>
                    <input
                        type="text"
                        value={query}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search..."
                        style={{
                            width: "100%",
                            padding: "10px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            position: "relative",
                            zIndex: 1,
                        }}
                        onBlur={() => setTimeout(() => setShowResults(false), 200)}
                        onFocus={() => searchApiResults.length > 0 && setShowResults(true)}
                    />
                    {showResults && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                width: "100%",
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: "#fff",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                zIndex: 2,
                                paddingLeft: "10px",
                            }}
                        >
                            {searchApiResults.length > 0 ? (
                                searchApiResults.map((item, index) => (
                                    <div
                                        key={item.id || item.value || index}
                                        onClick={() => handleExternalResultClick(item)}
                                        style={{
                                            padding: "10px 0",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                            textAlign: "left",
                                            backgroundColor: "#f9f9f9",
                                        }}
                                        onMouseOver={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#eee")
                                        }
                                        onMouseOut={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#f9f9f9")
                                        }
                                    >
                                        <div style={{ fontWeight: 'bold' }}>
                                        {item.key + ' -> ' + (item.title || item.name)}
                                        </div>

                                    </div>
                                ))
                            ) : (
                                <p style={{ padding: "10px", color: "#d93025", textAlign: "center" }}>
                                    No matching results found.
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(SearchPage);
